import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Call from '../components/Call';
import { answerCall, endCall, holdCallAndDeactivate } from '../reducers/calls';
import styles from '../styles/callList.scss';
import { HangUpIcon, NewCallIcon, PhoneIcon } from './icons';
const CallList = () => {
    const dispatch = useDispatch();
    const calls = useSelector((state) => state.calls || []);
    const [containerVisible, setContainerVisible] = useState(false);
    const activeCall = calls.find((c) => c.active);
    const ongoingCallCount = calls.length;
    let title = `${ongoingCallCount} Ongoing ${ongoingCallCount === 1 ? 'Call' : 'Calls'}`;
    const incomingCall = calls.find((c) => c.direction === 'IN' && c.ringing);
    if (incomingCall) {
        title = `Incoming call from ${incomingCall.number}`;
    }
    const containerBaseClass = ongoingCallCount
        ? styles.container
        : styles.container_empty;
    const containerVisibleClass = containerVisible && ongoingCallCount
        ? styles.container_open
        : styles.container_closed;
    const containerStatusClass = incomingCall && !containerVisible ? styles.container_active : '';
    const containerClass = `
      ${containerBaseClass}
      ${containerVisibleClass}
      ${containerStatusClass}
    `;
    let quickActions = null;
    if (activeCall) {
        if (incomingCall) {
            quickActions = (React.createElement("span", { className: styles.clickable },
                React.createElement("span", { className: styles.icon_container_green, onClick: () => {
                        dispatch(answerCall(incomingCall.id));
                    } },
                    React.createElement(PhoneIcon, null)),
                React.createElement("span", { className: styles.icon_container_red, onClick: () => {
                        dispatch(endCall(incomingCall.id));
                    } },
                    React.createElement(HangUpIcon, null))));
        }
        else {
            quickActions = (React.createElement("span", { className: styles.clickable },
                React.createElement("button", { className: styles.icon_container, onClick: () => {
                        setContainerVisible(false);
                        dispatch(holdCallAndDeactivate(activeCall === null || activeCall === void 0 ? void 0 : activeCall.id));
                    } },
                    React.createElement(NewCallIcon, null))));
        }
    }
    return (React.createElement("div", { className: containerClass },
        ongoingCallCount ? (React.createElement("div", { className: styles.call_summary },
            React.createElement("span", { className: styles.call_summary_title, onClick: () => {
                    setContainerVisible(!containerVisible);
                } }, title),
            quickActions)) : (''),
        ongoingCallCount ? (React.createElement("ul", { className: styles.list, onClick: () => {
                setContainerVisible(false);
            } }, calls.map((call, i) => {
            return React.createElement(Call, { key: i, id: call.id });
        }))) : (React.createElement("span", { className: styles.empty_message }, "No ongoing calls"))));
};
export default CallList;
